<template>
    <div class="w-768">
        <multi-lang-toggle :form="form"></multi-lang-toggle>

        <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs" class="w-full mb-32">
            <div v-for="lang in languages" :key="lang">
                <simple-input
                    v-show="lang === selectedLanguage"
                    v-model="form.title[lang]"
                    emojis
                    class="mb-16"
                >
                    {{ $t('form.title') }} <span v-if="languages.length > 1">({{ lang }})</span>
                    <span class="text-body-sm">{{ $t('general.optional') }}</span>
                </simple-input>

                <wysiwyg
                    v-show="lang === selectedLanguage"
                    v-model="form.description[lang]"
                    full-featured
                >
                    {{ $t('form.description') }} <span v-if="languages.length > 1">({{ lang }})</span>
                </wysiwyg>
            </div>
        </translatable>

        <div class="border-b-2 border-primary-20 mb-32"></div>

        <div class="pt-4 mb-16">
            <toggle v-model="transChecked">
                {{ $t('site_editor.video.per_language') }}
            </toggle>
        </div>

        <div v-show="transChecked">
            <translatable #default="{ languages, selectedLanguage }" :errors="warningTabsUrl" class="w-full">
                <div v-for="lang in languages" :key="lang">
                    <preview-video
                        v-show="lang === selectedLanguage"
                        :value="form.translated_url[lang]"
                        :language="lang"
                        @update="updateVideoUrl($event, lang)">
                    </preview-video>
                </div>
            </translatable>
        </div>

        <div v-show="!transChecked">
            <preview-video
                :value="form.url"
                @update="updateVideoUrl($event)">
            </preview-video>
        </div>

    </div>
</template>

<script>
import Translatable from '../forms/Translatable.vue';
import Input from '../forms/Input.vue';
import { videoPlayer } from '../../mixins/videoPlayer';
import LanguagesMultiToggle from '../forms/LanguagesMultiToggle.vue';
import PreviewVideo from './PreviewVideo.vue';
import Toggle from '../forms/Toggle.vue';
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';
import wysiwyg from "../forms/Wysiwyg.vue";

export default {
    components: {
        wysiwyg,
        'multi-lang-toggle': LanguagesMultiToggle,
        'preview-video': PreviewVideo,
        'simple-input': Input,
        'toggle': Toggle,
        'translatable': Translatable,
    },
    mixins: [videoPlayer()],
    props: {
        form: {
            required: true,
        }
    },
    data () {
        return {
            tmpTransUrls : {},
            transChecked: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.title[languages[index]] && this.form.data.published[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
        warningTabsUrl() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.translated_url[languages[index]] && this.form.data.published[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
    },
    methods: {
        updateVideoUrl (value, locale) {
            if (typeof locale != 'undefined') {
                this.form.translated_url[locale] = value;
            } else {
                this.form.url = value;
            }
        },
    },
    created () {
        for (let lang of Object.keys(this.form.translated_url)) {
            this.tmpTransUrls[lang] = this.form.translated_url[lang];

            if (this.form.translated_url[lang]) {
                this.transChecked = true;
            }
        }
    },
    watch: {
        transChecked (value, oldValue) {
            if (value) {
                //re-populate lang form inputs
                for (let lang of Object.keys(this.tmpTransUrls)) {
                    this.form.translated_url[lang] = this.tmpTransUrls[lang];
                }
            } else {
                //hold lang form inputs values and empty them
                for (let lang of Object.keys(this.form.translated_url)) {
                    this.tmpTransUrls[lang] = this.form.translated_url[lang];
                    this.form.translated_url[lang] = null;
                }
            }
        }
    }
}
</script>
